import { ApiClient } from "lib/utils/client/apiClient";

export const GetAllResidents = async () => {
  return ApiClient("/residents", {
    method: "GET",
  });
};

export const GetAllCondos = async () => {
  return ApiClient("/condos/findAll", {
    method: "GET",
  });
};

export const AddGuestRequest = async (data: any) => {
  return ApiClient("/guest-access", {
    method: "POST",
    body: JSON.stringify(data),
  });
};

export const GetGuestRequests = async ({
  page,
  limit,
  search,
}: {
  page: number;
  limit: number;
  search?: string;
}) => {
  const payload: any = { page, limit };
  if (search && search.trim().length > 0) payload.search = search.trim();
  return ApiClient("/guest-access/all", {
    method: "POST",
    body: JSON.stringify(payload),
  });
};

export const GetGuestAccessStats = async () => {
  return ApiClient("/guest-access/stats", {
    method: "GET",
  });
};

export const WithdrawGuestAccess = async (id: string) => {
  return ApiClient(`/guest-access/withdraw-access`, {
    method: "POST",
    body: JSON.stringify({ guestPassId: id }),
  });
};

export const GenerateNewOtp = async (id: string) => {
  return ApiClient(`/guest-access/generate-new-otp`, {
    method: "POST",
    body: JSON.stringify({ guestPassId: id }),
  });
};

export const GetGuestAccessHistory = async ({
  page,
  limit,
  search,
}: {
  page: number;
  limit: number;
  search?: string;
}) => {
  const payload: any = { page, limit };
  if (search && search.trim().length > 0) payload.search = search.trim();
  return ApiClient("/guest-access/history", {
    method: "POST",
    body: JSON.stringify(payload),
  });
};

export const ApproveGuestPass = async (id: string) => {
  return ApiClient(`/guest-access/${id}/approve`, {
    method: "PATCH",
  });
};

export const RejectGuestPass = async (id: string) => {
  return ApiClient(`/guest-access/${id}/reject`, {
    method: "PATCH",
  });
};
